// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + (chunkId === 252 ? "__federation_expose_AppMount" : chunkId) + "." + {"29":"a70273b1","31":"f7cb8a6b","69":"32e6e317","124":"8eb5d9f7","246":"a7839706","252":"075833e0","418":"7363f478","442":"e90d5955","667":"e91e5718","965":"ede950b5"}[chunkId] + ".chunk.js";
};